module.exports = __webpack_public_path__ + "2eed31d216cd1f7881147971e0426d54.svg";